import React, { useState } from 'react';
import { useContracts } from '../../../context/ContractContext';
import Card from '../../common/Card';
import Button from '../../common/Button';
import Loader from '../../common/Loader';
import { toBN } from '../../../utils/format';
import { useTxRunner } from './AdminHelpers';

export default function UserOps() {
  const { mainW, viewsW } = useContracts();
  const { busy, run } = useTxRunner();

  // Blacklist
  const [blUid, setBlUid] = useState('');
  const [blStatus, setBlStatus] = useState(true);

  // Virtual register
  const [vrAddr, setVrAddr] = useState('');
  const [vrRef, setVrRef] = useState('');

  // Virtual investment
  const [viAddr, setViAddr] = useState('');
  const [viAmt, setViAmt] = useState('');
  const [viRef, setViRef] = useState('');

  // Leader investment
  const [liAddr, setLiAddr] = useState('');
  const [liAmt, setLiAmt] = useState('');
  const [liRef, setLiRef] = useState('');

  // Mark reward given
  const [mrUid, setMrUid] = useState('');
  const [mrLvl, setMrLvl] = useState('');

  // Batch mark
  const [bmUids, setBmUids] = useState('');
  const [bmLvl, setBmLvl] = useState('');

  // Emergency withdraw
  const [ewToken, setEwToken] = useState('USDT');
  const [ewAmt, setEwAmt] = useState('');

  const parseUids = (s) => s.split(/[,\s]+/).map((x) => x.trim()).filter(Boolean);

  return (
    <>
      {busy && <Loader text={busy} />}

      <div className="grid grid-2 mb-4">
        <Card title="Blacklist User">
          <div className="input-group">
            <label className="input-label">User ID</label>
            <input className="input" type="number" value={blUid} onChange={(e) => setBlUid(e.target.value)} placeholder="e.g. 12345" />
          </div>
          <div className="input-group">
            <label className="input-label">Action</label>
            <select className="input" value={blStatus ? '1' : '0'} onChange={(e) => setBlStatus(e.target.value === '1')}>
              <option value="1">Blacklist</option>
              <option value="0">Un-blacklist</option>
            </select>
          </div>
          <Button block variant={blStatus ? 'danger' : 'success'} disabled={!blUid} onClick={() =>
            run(blStatus ? 'Blacklisting user' : 'Un-blacklisting user',
              () => mainW.blacklistUser(blUid, blStatus))
          }>
            {blStatus ? 'BLACKLIST' : 'UN-BLACKLIST'}
          </Button>
        </Card>

        <Card title="Mark Reward Given">
          <div className="input-group">
            <label className="input-label">User ID</label>
            <input className="input" type="number" value={mrUid} onChange={(e) => setMrUid(e.target.value)} placeholder="User ID" />
          </div>
          <div className="input-group">
            <label className="input-label">Tier (0-10)</label>
            <input className="input" type="number" min="0" max="10" value={mrLvl} onChange={(e) => setMrLvl(e.target.value)} />
          </div>
          <Button block variant="warning" disabled={!mrUid || mrLvl === ''} onClick={() =>
            run('Marking reward given', () => mainW.markRewardGiven(mrUid, mrLvl))
          }>MARK GIVEN</Button>
        </Card>
      </div>

      <Card title="Batch Mark Rewards Given" className="mb-4">
        <div className="input-group">
          <label className="input-label">User IDs (comma or space separated)</label>
          <textarea
            className="input"
            rows="2"
            value={bmUids}
            onChange={(e) => setBmUids(e.target.value)}
            placeholder="1234, 5678, 9012"
            style={{ resize: 'vertical', fontFamily: 'var(--font-mono)' }}
          />
        </div>
        <div className="input-group">
          <label className="input-label">Tier (0-10)</label>
          <input className="input" type="number" min="0" max="10" value={bmLvl} onChange={(e) => setBmLvl(e.target.value)} />
        </div>
        <Button block variant="primary" disabled={!bmUids || bmLvl === ''} onClick={() =>
          run('Batch marking', () => viewsW.markRewardGivenBatch(parseUids(bmUids), bmLvl))
        }>BATCH MARK ({parseUids(bmUids).length})</Button>
      </Card>

      <div className="grid grid-3 mb-4">
        <Card title="Virtual Register">
          <div className="input-group">
            <label className="input-label">Wallet Address</label>
            <input className="input mono" value={vrAddr} onChange={(e) => setVrAddr(e.target.value)} placeholder="0x..." />
          </div>
          <div className="input-group">
            <label className="input-label">Referrer ID</label>
            <input className="input" type="number" value={vrRef} onChange={(e) => setVrRef(e.target.value)} placeholder="0 = default" />
          </div>
          <Button block variant="primary" disabled={!vrAddr} onClick={() =>
            run('Registering virtually', () => mainW.virtualRegister(vrAddr, vrRef || 0))
          }>VIRTUAL REGISTER</Button>
        </Card>

        <Card title="Virtual Investment">
          <div className="input-group">
            <label className="input-label">Wallet Address</label>
            <input className="input mono" value={viAddr} onChange={(e) => setViAddr(e.target.value)} placeholder="0x..." />
          </div>
          <div className="input-group">
            <label className="input-label">Amount (USD)</label>
            <input className="input" type="number" value={viAmt} onChange={(e) => setViAmt(e.target.value)} placeholder="e.g. 500" />
          </div>
          <div className="input-group">
            <label className="input-label">Referrer ID</label>
            <input className="input" type="number" value={viRef} onChange={(e) => setViRef(e.target.value)} placeholder="0 = default" />
          </div>
          <Button block variant="primary" disabled={!viAddr || !viAmt} onClick={() =>
            run('Virtual investment', () => mainW.virtualInvestment(viAddr, toBN(viAmt), viRef || 0))
          }>VIRTUAL INVEST</Button>
        </Card>

        <Card title="Leader Investment">
          <div className="input-group">
            <label className="input-label">Wallet Address</label>
            <input className="input mono" value={liAddr} onChange={(e) => setLiAddr(e.target.value)} placeholder="0x..." />
          </div>
          <div className="input-group">
            <label className="input-label">Amount (USD)</label>
            <input className="input" type="number" value={liAmt} onChange={(e) => setLiAmt(e.target.value)} placeholder="e.g. 5000" />
          </div>
          <div className="input-group">
            <label className="input-label">Referrer ID</label>
            <input className="input" type="number" value={liRef} onChange={(e) => setLiRef(e.target.value)} placeholder="0 = default" />
          </div>
          <Button block variant="success" disabled={!liAddr || !liAmt} onClick={() =>
            run('Leader investment', () => mainW.leaderInvestment(liAddr, toBN(liAmt), liRef || 0))
          }>LEADER INVEST</Button>
        </Card>
      </div>

      <Card title="Emergency Withdraw">
        <div className="grid grid-3">
          <div className="input-group">
            <label className="input-label">Token</label>
            <select className="input" value={ewToken} onChange={(e) => setEwToken(e.target.value)}>
              <option value="USDT">USDT</option>
              <option value="TOKEN2">Token2</option>
            </select>
          </div>
          <div className="input-group">
            <label className="input-label">Amount (USD)</label>
            <input className="input" type="number" value={ewAmt} onChange={(e) => setEwAmt(e.target.value)} placeholder="Amount to withdraw" />
          </div>
          <div className="input-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Button block variant="danger" disabled={!ewAmt} onClick={() => {
              const fn = ewToken === 'USDT'
                ? () => mainW.emergencyWithdrawUSDT(toBN(ewAmt))
                : () => mainW.emergencyWithdrawToken2(toBN(ewAmt));
              run(`Emergency withdrawing ${ewToken}`, fn);
            }}>EMERGENCY WITHDRAW</Button>
          </div>
        </div>
      </Card>
    </>
  );
}
